var exports = {
  "Lw": "VoiceRegionTeleportOverlay.module__overlay___NkYtNV",
  "t5": "VoiceRegionTeleportOverlay.module__voiceRegionTeleportFadeIn___NkYtNV",
  "Vs": "VoiceRegionTeleportOverlay.module__tile___NkYtNV",
  "Pf": "VoiceRegionTeleportOverlay.module__label___NkYtNV",
};

module.exports = exports;
